<template>
  <div class="p_b_100">
    <!-- 横幅滑动 -->
    <banner-swiper-slide :list="banners"></banner-swiper-slide>
    <!-- 四方格 -->
    <checkered-pattern :list="patterns"></checkered-pattern>
    <!-- 创新故事 -->
    <innovation-story :innovationStory="innovationStory"></innovation-story>
    <!-- 附属产品介绍 -->
    <child-module :childModule="childModule"></child-module>
  </div>
</template>

<script>
export default {
  name: "home-default",
  components: {},
  data() {
    return {
      // 横幅滑动
      banners: [],
      // 四方格
      patterns: [],
      // 创新故事
      innovationStory: {},
      // 附属产品介绍
      childModule: {}
    };
  },
  created() {
    this.$api.dispatch("home.getBanners").then(data => {
      this.banners = data;
    });
    this.$api.dispatch("home.getPatterns").then(data => {
      this.patterns = data;
    });
    this.$api.dispatch("home.getInnovationStory").then(data => {
      this.innovationStory = data;
    });
    this.$api.dispatch("home.getChilModule").then(data => {
      this.childModule = data;
    });
  }
};
</script>

<style lang="scss" scoped>
</style>
